import Service from '../../services'
import { checkAndReturn } from "../../main"

const state = {

}

const getters = {

}

const actions = {
    getPlanForEdit ({ commit }, params) {
        return Service.MonthlyProgress.getPlanForEdit(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    updatePlan ({ commit }, params) {
        return Service.MonthlyProgress.updatePlan(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    getProgressRSP ({ commit }, params) {
        return Service.MonthlyProgress.getProgressRSP(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    extendProgressMonth ({ commit }, params) {
        return Service.MonthlyProgress.extendProgressMonth(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    updateProgressData ({ commit }, params) {
        return Service.MonthlyProgress.updateProgressData(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },
}

const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
